import { createSlice } from '@reduxjs/toolkit';
import { AppState, AddToWalletSlice } from '../interfaces/store.interface';

export const initialState: AddToWalletSlice = {
  walletType: '',
  clientId: '',
  productType: '',
};

export const addToWallet = 'addToWallet';

export const addToWalletSlice = createSlice({
  name: addToWallet,
  initialState,
  reducers: {
    setAccountAddToWallet: (state, action) => {
      state.walletType = action.payload.walletType;
      state.clientId = action.payload.clientId;
      state.productType = action.payload.productType;
    },
  },
});

// state actions can be exported here
export const { setAccountAddToWallet } = addToWalletSlice.actions;

export default addToWalletSlice.reducer;

// state getters can be written & exported here
export const getWalletType = (state: AppState) => state.addToWallet?.walletType;
